import { makeStyles } from '@material-ui/core/styles';

import imgTexture from '../../assets/img/login/texture.png';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    backgroundColor: theme.palette.primary.main,
    height: '100%',
    overflow: 'auto',
  },
  colLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundImage: `url("${imgTexture}")`,
    color: theme.palette.background.default,
    [theme.breakpoints.only('xs')]: {
      order: 2,
    },
  },
  colRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.only('xs')]: {
      order: 1,
      border: `16px solid ${theme.palette.primary.main}`,
    },
  },
  welcome: {
    margin: theme.spacing(4),
    maxWidth: 560,
  },
  imgLogo: {
    position: 'absolute',
    top: theme.spacing(3),
    right: theme.spacing(3),
    filter: 'drop-shadow(0 0 0.75rem rgba(0, 0, 0, .2))',
    maxWidth: 160,
    width: '100%',
  },
  form: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    margin: theme.spacing(2),
  },
  formTitle: {
    fontWeight: 'bold',
  },
}));

export default useStyles;
